module.exports = __webpack_public_path__ + "img/tghd_img_bx3.647d950c.webp";